import { transport } from 'config/transport';

export function callApiDeleteAsset(congDoanId, id, assetType) {
    return transport.del(`congDoan/${congDoanId}/assets/${id}`, { params: { assetType } });
}
